import styled, { createGlobalStyle } from 'styled-components'

const color = {
  brand: '#38D35C',
  background: '#F8F8F8',
  brand_rgba: 'rgb(56, 211, 92,0.15)',
  cancel: '#D3384B',
}

const GlobalStyleBody = createGlobalStyle`
@font-face {
  font-family: "Leelawadee";   /*Can be any text*/
  src: local("Leelawadee"),
    url("fonts/Roboto-Rergular.ttf") format("truetype");
}

  body {
  
    background:  ${({ theme }) => theme.background_secundary};
    padding:0;
    margin:0;
    overscroll-behavior-x: none;
    overflow:hidden!important;
    color:  ${({ theme }) => theme.primary};
    
  }

  * {
  
  font-family: 'Roboto','Leelawadee', sans-serif;
  margin:0px;
  box-sizing: border-box;
  background:none;
  border:none;

  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

  button {
    font-weight:bold;
    cursor:pointer;
    color: ${({ theme }) => theme.primary};
  }
`

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: 22px;
  margin-bottom: 1.4vh;
  text-align: center;
`

export const ButtonSubmit = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  margin: ${(props) => props.margin};
  padding: ${(props) => (props.rounded ? '20px' : '2px 12px 2px 12px')};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  height: 38px;
  height: ${(props) => props.height};
  color: #fff;
  border-radius: ${(props) => (props.rounded ? '360px' : '3px')};
  background: ${color.brand};
  background: ${(props) => props.background};
  font-size: ${(props) => props.fontSize};
  svg {
    font-size: 18px;
    margin-right: ${(props) => (props.rounded ? '0px' : '6px')};
  }

  ${(props) => (props.medium ? `font-size:15px; height:44px;` : null)};
  color: ${(props) => props.colorFont}!important;
  ${(props) =>
    props.invert
      ? `color: ${color.brand}; background-color: ${props.theme.background}; border: 1px solid ${color.brand}`
      : null}
`

export const FlexContainer = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 100svh;
`

export const Container = styled.div`
  padding: 2vh;
`

export const Content = styled.div`
  width: 100%;
  padding: 2vw;
  padding-top: 55px;
  z-index: 3;
  overflow: auto;
  height: 100svh;
`
export const AllScreen = styled.div`
  width: 100%;
`

export { GlobalStyleBody, color }
